<template>
  <div>
    <div class="w-100 d-inline-block bg-book-banner-image">
      <div class="container autoContent">
        <div class="row margin-top-3 margin-bottom-3">
          <div class="col-12">
            <div class="w-50 d-block text-center m-auto booking-banner position-relative w-xs-100 w-sm-100 w-md-100 w-ipad-100">
              <h1 class="text-black fw-bold text-full-24 filson-black-family margin-bottom-2 margin-top-2 text-size-24" data-bs-toggle="modal" data-bs-target="#AddressDetailModal">
                Date & Time
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-book-detail-image position-relative bg-date-banner-image">
      <div class="container autoContent">
        <div class="row margin-top-3 margin-bottom-3">
          <div class="col-12 col-xl-9 mb-xl-0 mb-2 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block bg-introduction rounded-3 padding-2">
              <div class="w-100 d-inline-block padding-2 rounded-3 bg-white margin-top-3 pb-0">
    <h2 class="text-black fw-bold text-size-14 medium-family text-full-13 margin-bottom-2">
      <img class="date-icon-image" src="@/assets/images/date-image-icon.svg" alt="image" />
      Date
    </h2>
    <div class="w-100 d-inline-block 
    position-relative">
      <ul class="w-100 d-flex p-0 text-center client-date-section mb-0">
        <li
          v-for="(date, index) in displayedDates"
          :key="index"
          class="float-start"
        >
          <a
            class="d-inline-block rounded-3 padding-2 w-100 bg-introduction text-black"
            href="javascript:void(0)"
            :class="{ activeClient: activeLink2 === index + 1 }"
            @click="setActiveLink2(index + 1)"
          >
            <span class="d-block text-size-14 medium-family text-full-12">{{ date.day }}</span>
            <span class="d-block text-size-14 fw-bold inter-bold-family text-full-14">
              {{ date.date }}
            </span>
            <span class="d-block text-size-14 medium-family text-full-12">{{ date.month }}</span>
          </a>
        </li>
      </ul>
      <a @click="loadPrevDates" href="javascript:void(0)" class="position-absolute angle-left-slide-icon text-black">
        <i class="fa fa-angle-left" aria-hidden="true">
      </i>
      </a>
      <a @click="loadNextDates" href="javascript:void(0)" class="position-absolute angle-right-slide-icon 
      text-black">
        <i class="fa fa-angle-right" aria-hidden="true">
      </i>
      </a>
    </div>
  </div>
  <div class="w-100 d-inline-block padding-2 rounded-3 bg-white margin-top-3 pb-0">
    <h2 class="text-black fw-bold text-size-14 medium-family text-full-13 margin-bottom-2">
      <img class="date-icon-image" src="@/assets/images/time-image-icon.svg" alt="image" />
      Time
    </h2>
    <div class="w-100 d-inline-block">
      <ul class="w-100 d-inline-block p-0 text-center client-date-section mb-0">
        <li 
          v-for="(slot, index) in timeSlots" 
          :key="index" 
          class="float-start margin-bottom-2 position-relative"
        >
          <button 
            class="d-inline-block rounded-3 w-100 text-size-14 text-black medium-family text-full-12 text-center"
            :class="{
              'bg-introduction': slot.isAvailable,
              'btn-secondary disabled': !slot.isAvailable,
              'activeTime': activeLink === index && slot.isAvailable,
              'text-gray': !slot.isAvailable
            }"
            :disabled="!slot.isAvailable"
            @click="slot.isAvailable ? setActiveLink(index, slot) : showTooltip(index)" 
            @mouseover="showTooltip(index)"
            @mouseleave="hideTooltip"
          >
            {{ slot.time }}
          </button>
          <!-- Custom Tooltip -->
          <div 
            v-if="tooltipIndex === index && !slot.isAvailable" 
            class="custom-tooltip"
          >
            This slot is booked
          </div>
        </li>
      </ul>
<!-- Tooltip for booked slots -->
      <!-- <ul class="w-100 d-inline-block p-0 text-center client-date-section mb-0">
        <li v-for="(slot, index) in timeSlots" :key="index" class="float-start margin-bottom-2">
            <button 
                class="d-inline-block rounded-3 w-100 text-size-14 text-black medium-family text-full-12 text-center"
                :class="{
                    'bg-introduction': slot.isAvailable,
                    'btn-secondary disabled': !slot.isAvailable,
                    'activeTime': activeLink === index && slot.isAvailable
                }"
                :disabled="!slot.isAvailable"
                @click="setActiveLink(index, slot)"
            >
                {{ slot.time }}
            </button>
        </li>
    </ul> -->

    </div>
  </div>
              <div class="w-100 d-inline-block padding-2 rounded-3 bg-gallery margin-top-3">
                <h2 class="dark-black fw-bold text-size-14 medium-family w-100 d-inline-block margin-bottom-2 text-full-13">
                  <img class="float-start margin-right-2 date-icon-image" src="@/assets/images/note-image-icon.svg" alt="image" />
                  <span class="float-start w-92 w-xs-85 w-md-90">
                    Any instructions or special requirements?
                  </span>
                </h2>
                <div class="w-100 d-inline-block select-textarea">
                  <textarea class="form-control bg-white rounded-3 text-size-16 text-full-12" id="Textarea" rows="3" placeholder="Example: Allergies, bites, shy behavior, medical issues, or anything we should know."></textarea>
                </div>
              </div>
              <div class="accordion policy-accordian margin-top-2" id="accordionExample">
  <div class="accordion-item">
    <h2 class="accordion-header w-100 d-inline-block padding-2 rounded-3 bg-white">
      <button class="accordion-button collapsed p-0" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
        <img class="float-start margin-right-2 date-icon-image" src="@/assets/images/task-square-icon.svg" alt="image" />
          <span class="float-start w-92 w-xs-85 w-md-90 dark-black fw-bold text-size-14 medium-family w-100 d-inline-block text-full-13">
            Free cancellation until 12 hours before the start of your booking
          </span>
      </button>
    </h2>
    <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div class="accordion-body padding-2">
        <div class="w-100 d-inline-block policy-table">
           <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="type-text text-size-12 mb-0 fw-bold inter-semi-bold text-full-12">Type</th>
                  <th scope="col" class="type-text text-size-12 mb-0 fw-bold inter-semi-bold text-full-12"> Cancellation Fee </th>
                  <th scope="col" class="type-text text-size-12 mb-0 fw-bold inter-semi-bold text-full-12">Reschedule Fee</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="type-text text-size-14 inter-regular-family text-full-11">10 minutes after placing the request</td>
                  <td class="type-text text-size-14 inter-regular-family text-full-11"> Free of charge </td>
                  <td class="type-text text-size-14 inter-regular-family text-full-11"> Free of charge </td>
                </tr>
                <tr>
                  <td class="type-text text-size-14 inter-regular-family text-full-11"> 12+ hours before the appointment </td>
                  <td class="type-text text-size-14 inter-regular-family text-full-11"> Free of charge 
                  </td>
                  <td class="type-text text-size-14 inter-regular-family text-full-11"> Free of charge </td>
                </tr>
                <tr>
                  <td class="type-text text-size-14 inter-regular-family text-full-11"> 2-12 hours before the appointment </td>
                  <td class="type-text text-size-14 inter-regular-family text-full-11"> 25% of appointment value </td>
                  <td class="type-text text-size-14 inter-regular-family text-full-11"> 25% of appointment value </td>
                </tr>
                <tr>
                  <td class="type-text text-size-14 inter-regular-family text-full-11"> Less than 2 hours before the appointment </td>
                  <td class="type-text text-size-14 inter-regular-family text-full-11"> 50% of appointment value </td>
                  <td class="type-text text-size-14 inter-regular-family text-full-11"> 50% of appointment value </td>
                </tr>
                <tr>
                  <td class="type-text text-size-14 inter-regular-family text-full-11"> Missed appointment </td>
                  <td class="type-text text-size-14 inter-regular-family text-full-11"> 100% of appointment value </td>
                  <td class="type-text text-size-14 inter-regular-family text-full-11"> 100% of appointment value </td>
                </tr>
              </tbody>
            </table>
        </div>
      </div>
    </div>
  </div>
</div>
              
            </div>
          </div>
          <div class="col-12 col-xl-3 mb-xl-0 margin-bottom-2 col-md-6 col-lg-6 d-xl-inline-block d-none d-md-block d-lg-block">
            <div class="w-100 d-inline-block bg-introduction rounded-3 padding-bottom-3 padding-2 booking-detail-box" style="position:sticky;top:8vw;">
              <p class="text-black text-size-14 mb-0 inter-semi-bold text-full-13">Booking Details</p>
              <div class="w-100 d-inline-block bg-white rounded-top margin-top-2">
                <div class="w-100 d-inline-block border-bottom padding-2">
                  <div class="row">
                    <div class="col-xl-4 col-5 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 strike-text medium-family text-full-11">
                          Service
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-8 col-7 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-black medium-family text-full-11">
                          Dog, Cat Grooming
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-inline-block padding-2 booking-scroll">
                  <div class="row border-bottom padding-bottom-1">
                    <div class="col-xl-8 col-8 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 strike-text medium-family text-full-11">
                          Service Details
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-4 col-4 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <a href="javascript:void(0)" class="text-size-14 edit-text inter-bold-family text-full-11">
                          <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                          Edit
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-for="(item, index) in cart" :key="index">
                  <div class="row border-bottom padding-bottom-1 padding-top-1">
                    <div class="col-xl-7 col-7 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 text-black medium-family text-full-11">
                          {{item.name}} ({{item.plan_detail.plan.name}})
                          <span class="text-green">x{{item.count}}</span>
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-5 col-5 mb-xl-0 mb-2 ps-xl-0">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-green medium-family text-full-11"> AED {{item.price * item.count}} 
                        </span>
                        <span class="text-size-14 text-red cursor-pointer ms-1 text-full-13" 
                        @click="removeItem(index)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </span>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
              <div class="w-100 d-inline-block rounded-3 bg-gallery margin-top-2">
                <div class="w-100 d-inline-block border-bottom p-2">
                  <p class="text-size-14 text-black mb-0 medium-family text-full-12">
                    Payment Summary
                  </p>
                </div>
                <div class="w-100 d-inline-block padding-2">
                  <div class="row">
                    <div class="col-xl-6 col-7 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 strike-text medium-family text-full-11">Total </span>
                      </div>
                    </div>
                    <div class="col-xl-6 col-5 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-green medium-family text-full-11">
                          AED {{ cartTotal }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-inline-block bg-white rounded-3 margin-top-2">
                <div class="w-100 d-inline-block border-bottom padding-2">
                  <p class="text-size-14 strike-text mb-0 medium-family text-full-12">
                    Address
                  </p>
                </div>
                <div class="w-100 d-inline-block padding-2">
                  <p class="text-size-14 dark-black mb-0 family-inter-light text-full-11 location-address">
                   {{ address }}
                  </p>
                </div>
              </div>
              <div class="w-100 d-inline-block margin-top-2 text-center">
                <a ref="nextButton" class="bg-green rounded-5 text-white d-inline-block padding-1 w-100 inter-semi-bold text-size-14 text-full-14 line-height-25" href="javascript:void(0)" @click="saveAppointment()">
                  Next
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block 
    bg-introduction margin-top-3">
      <div class="container autoContent">
        <div class="row margin-top-2 margin-bottom-2">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0 margin-top-1">
        <li class="float-start margin-right-2">
          <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
            <i class="fa fa-home nav-color" aria-hidden="true"></i>
            Home  /
          </a>
        </li>
        <li class="float-start">
          <a class="text-black text-size-14 medium-family text-full-13" href="javascript:void(0)">
            Services
          </a>
        </li>
      </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-xl-none d-block d-md-none d-lg-none sticky-booking-footer text-center bg-white box-shadow">
      <div class="container">
        <div class="row showNext">
          <div class="col-6 mt-1">
            <div class="w-100 d-inline-block text-start ps-xl-0 ps-3" data-bs-toggle="modal" data-bs-target="#bookStickyBackdrop">
              <p class="mb-0 text-size-17 strike-text medium-family">
                Total
              </p>
              <span class="text-size-18 text-black medium-family fw-bold"> AED {{ cartTotal }} 
              </span>
              <span class="text-size-24 cursor-pointer ms-1">
                  <i class="fa fa-angle-up" aria-hidden="true"></i>
              </span>
            </div>
          </div>
          <div class="col-6 mt-2">
            <div class="w-100 d-inline-block">
              <a ref="nextButton" class="bg-green rounded-5 text-white d-inline-block next-btn w-100 inter-semi-bold text-size-18 line-height-25" href="javascript:void(0)" @click="saveAppointment()">
                  Next
                </a>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--start book sticky modal -->
<div class="modal fade" id="bookStickyBackdrop" data-bs-backdrop="true" data-bs-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header pb-0 border-bottom-0 padding-top-3 w-100 d-inline-block">
        <h1 class="text-black text-size-14 text-full-14 mb-0 medium-family float-start" id="staticBackdropLabel">Booking Details</h1>
        <button type="button" class="btn-close mt-0 rounded-circle p-0 d-inline-block close-btn float-end m-0" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <div class="modal-body">
         <div class="w-100 d-inline-block bg-introduction rounded-3 padding-bottom-3 padding-2">
              <div class="w-100 d-inline-block bg-white rounded-top margin-top-2">
                <div class="w-100 d-inline-block border-bottom padding-2">
                  <div class="row">
                    <div class="col-xl-4 col-5 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 strike-text medium-family text-full-11">
                          Service
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-8 col-7 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-black medium-family text-full-11">
                          Dog, Cat Grooming
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 d-inline-block padding-2">
                  <div class="row border-bottom padding-bottom-1">
                    <div class="col-xl-6 col-8 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 strike-text medium-family text-full-11">
                          Service Details
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-6 col-4 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <a href="javascript:void(0)" class="text-size-14 edit-text inter-bold-family text-full-11">
                          <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                          Edit
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-for="(item, index) in cart" :key="index">
                  <div class="row border-bottom padding-bottom-1 padding-top-1">
                    <div class="col-xl-7 col-7 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 text-black medium-family text-full-11">
                          {{item.name}} ({{item.plan_detail.plan.name}})
                          <span class="text-green">x{{item.count}}</span>
                        </span>
                      </div>
                    </div>
                    <div class="col-xl-5 col-5 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-green medium-family text-full-11"> AED {{item.price * item.count}} 
                        </span>
                        <span class="text-size-14 text-red cursor-pointer ms-1 text-full-13" 
                        @click="removeItem(index)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </span>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
              <div class="w-100 d-inline-block rounded-3 bg-gallery margin-top-2">
                <div class="w-100 d-inline-block border-bottom p-2">
                  <p class="text-size-14 text-black mb-0 medium-family text-full-12">
                    Payment Summary
                  </p>
                </div>
                <div class="w-100 d-inline-block padding-2">
                  <div class="row">
                    <div class="col-xl-6 col-7 mb-xl-0 mb-2">
                      <div class="w-100 d-inline-block">
                        <span class="text-size-14 strike-text medium-family text-full-11">Total </span>
                      </div>
                    </div>
                    <div class="col-xl-6 col-5 mb-xl-0 mb-2">
                      <div class="float-end d-inline-block">
                        <span class="text-size-14 text-green medium-family text-full-11">
                          AED {{ cartTotal }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-100 d-inline-block bg-white rounded-3 margin-top-2">
                <div class="w-100 d-inline-block border-bottom padding-2">
                  <p class="text-size-14 strike-text mb-0 medium-family text-full-12">
                    Address
                  </p>
                </div>
                <div class="w-100 d-inline-block padding-2">
                  <p class="text-size-14 dark-black mb-0 family-inter-light text-full-11">
                    {{ address }}
                  </p>
                </div>
              </div>
              <div class="w-100 d-inline-block margin-top-2 text-center mb-5">
                <a ref="nextButton" class="bg-green rounded-5 text-white d-inline-block padding-1 w-100 inter-semi-bold text-size-14 text-full-14 line-height-25 mb-4" href="javascript:void(0)" @click="saveAppointment()">
                  Next
                </a>
              </div>
            </div>
      </div>
    </div>
  </div>
</div>
<!--end book sticky modal -->

    <!--start mobile Number modal -->
    <div class="modal fade" id="MobileNumberModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content bg-introduction rounded-3">
          <div class="modal-header pb-0 border-bottom-0 padding-top-3 padding-left-3 padding-right-3 w-100 d-inline-block">
            <h1 class="text-black text-size-14 text-full-14 mb-0 medium-family float-start">
              Login or Sign Up
            </h1>
            <!-- <button type="button" class="btn-close mt-0 rounded-circle p-0 d-inline-block close-btn float-end m-0" @click="closeModal('MobileNumberModal')" aria-label="Close"></button> -->
          </div>
          <div class="modal-body padding-2">
            <form @submit.prevent="sendOtp">
              <div v-if="!otpSent" id="phone-nbr-cntr">
                <div class="w-100 d-inline-block padding-2 rounded-3 margin-top-2">
                  <label class="w-100 d-inline-block text-black text-size-14 medium-family text-full-13">
                    Your Phone number
                  </label>
                  <div class="w-100 d-inline-block rounded-2 margin-bottom-3 margin-top-2">
                     <PhoneNumberInput
                        v-model="phoneNumber"
                        @validation-changed="onPhoneValidationChanged"
                      />
                  </div>
                  
                </div>
                <div class="w-100 d-inline-block margin-top-3 margin-bottom-3">
                  <button
                    type="submit"
                    class="w-100 d-inline-block text-white text-size-14 inter-regular-family rounded-5 padding-2 text-uppercase text-center bg-blue border-0 text-full-13"
                    :disabled="loading"
                    >
                    <span v-if="!loading">Continue
                    </span>
                    <span v-if="loading">
                      <i class="fa fa-spinner fa-spin"></i> Sending...
                    </span>
                  </button>
                  <div class="w-100 d-inline-block margin-top-2">
                    <p class="text-size-14 text-black medium-family text-full-13">
                      Didn't receive the code? 
                      <a href="javascript:void(0)" @click="otpWhatsapp" class="text-blue">Chat here</a>
                    </p>
                </div>
                </div>
              </div>

              <div v-if="otpSent" class="w-100 d-inline-block padding-2 bg-white rounded-3 margin-top-3">
                <label class="w-100 d-inline-block text-black text-size-14 medium-family text-full-13">
                  Enter OTP
                </label>
                <div class="w-100 d-inline-block rounded-2 margin-bottom-3 input-contact margin-top-2">
                  <input
                    v-model="otp"
                    class="w-100 bg-introduction text-size-16 h-40 padding-left-3 padding-right-3 border rounded-2 text-full-13"
                    type="text"
                    placeholder="Enter OTP"
                    maxlength="6"
                    required
                  />
                </div>
                <button
                  @click="verifyOtp"
                  type="button"
                  class="w-100 d-inline-block text-white text-size-14 inter-regular-family rounded-5 padding-2 text-uppercase text-center bg-blue border-0 text-full-13"
                  :disabled="verifying"
                  >
                  <!-- Verify OTP -->
                  <span v-if="!verifying">Verify OTP
                  </span>
                  <span v-if="verifying">
                    <i class="fa fa-spinner fa-spin">
                    </i> Verifying...
                  </span>
                </button>
                <div class="w-100 d-inline-block margin-top-2">
                  <p class="text-size-14 text-black medium-family text-full-13">
                    Didn't receive the code? 
                    <a href="javascript:void(0)" @click="otpWhatsapp" class="text-blue">Chat here</a>
                  </p>
              </div>
            </div>

              <!-- Recaptcha -->
              <div id="recaptcha-container"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--start mobile Number modal -->
    <!--start contect detail modal -->
    <div class="modal fade" id="ContactDetailModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content bg-introduction rounded-3">
          <div class="modal-header pb-0 border-bottom-0 padding-top-3 padding-right-3 padding-left-3 w-100 d-inline-block">
            <h1 class="text-black text-size-14 text-ful-14 mb-0 medium-family float-start">
              Personal Details
            </h1>
            <button type="button" class="btn-close mt-0 rounded-circle p-0 d-inline-block close-btn float-end m-0" @click="closeModal('ContactDetailModal')" aria-label="Close"></button>
          </div>
          <div class="modal-body padding-2">
            <form @submit.prevent="saveUser">
              <div class="w-100 d-inline-block padding-2 bg-white rounded-3 margin-top-2">
                <label class="w-100 d-inline-block text-black text-size-14 medium-family text-full-13">Contact Information
                </label>
                <div class="w-100 d-inline-block rounded-2 margin-bottom-3 input-contact margin-top-2">
                  <input v-model="formData.name" class="w-100 bg-introduction text-size-16 h-40 padding-left-3 padding-right-3 border rounded-2 text-full-13" type="text" placeholder="Full Name" />
                </div>
              </div>
              <div class="w-100 d-inline-block padding-2 bg-white rounded-3 margin-top-3">
                <label class="w-100 d-inline-block text-black text-size-14 medium-family text-full-14">Email Address</label>
                <div class="w-100 d-inline-block rounded-2 margin-bottom-3 input-contact margin-top-2">
                  <input v-model="formData.email" class="w-100 bg-introduction text-size-16 h-40 padding-left-3 padding-right-3 border rounded-2 text-full-14" type="email" placeholder="Email Address" />
                </div>
              </div>
              <div class="w-100 d-inline-block padding-2 bg-white rounded-3 margin-top-3 margin-bottom-3">
                <label class="w-100 d-inline-block text-black text-size-14 medium-family text-full-14">Gender</label>
                <div class="w-100 d-inline-block margin-top-2 home-work-other-btn text-center">
                  <a @click="selectGender('Male')" :class="{'active': formData.gender === 'Male'}" class="text-black text-size-14 inter-bold-family bg-introduction rounded-5 text-uppercase d-inline-block margin-right-2 text-full-14">Male</a>
                  <a @click="selectGender('Female')" :class="{'active': formData.gender === 'Female'}" class="text-black text-size-14 inter-bold-family bg-introduction rounded-5 text-uppercase d-inline-block margin-right-2 text-full-14">Female</a>
                  <a @click="selectGender('Rather Not Say')" :class="{'active': formData.gender === 'Rather Not Say'}" class="text-black text-size-14 inter-bold-family bg-introduction rounded-5 text-uppercase d-inline-block text-full-14">Rather Not Say</a>
                </div>
              </div>
              <div class="w-100 d-inline-block padding-2 bg-white rounded-3 margin-top-3 margin-bottom-3">
                <ul class="w-100 d-inline-block padding-left-3">
                  <li style="list-style: disc !important;">
                    <span class="strike-text text-size-14 inter-regular-family text-full-14">
                      This information helps us refer you to relevant DubaiPetGroomer services.
                    </span>
                  </li>
                </ul>
              </div>
              <div class="w-100 d-inline-block margin-top-3 margin-bottom-3">
                <button type="submit" class="w-100 d-inline-block text-white text-size-14 inter-regular-family rounded-5 padding-2 text-uppercase text-center bg-blue border-0 text-full-14">
                  Save Information
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!--start contect detail modal -->

    <!--start address detail modal -->
    <div class="modal fade" id="AddressDetailModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content bg-introduction rounded-3">
          <div class="modal-header pb-0 border-bottom-0 padding-top-3 w-100 d-inline-block padding-left-3 padding-right-3">
            <h1 class="text-black mb-0 medium-family float-start text-size-14 text-full-14">Address Details</h1>
            <button type="button" class="btn-close mt-0 rounded-circle p-0 d-inline-block close-btn float-end m-0" @click="closeModal('AddressDetailModal')" aria-label="Close"></button>
          </div>
          <div class="modal-body padding-2">
            <!-- Location Search Input -->
            <div class="w-100 d-inline-block margin-top-2 position-relative">
              <form class="position-relative booking-banner" @submit.prevent>
                <input
                type="text"
                  v-model="searchQuery"
                  @input="handleInput"
                  placeholder="Search for area, street name, landmark..."
                  class="bg-white box-shadow rounded-3 border-0 text-size-16 text-full-13 w-100"
                />
                <a class="position-absolute location-icon" href="javascript:void(0)">
                  <img src="@/assets/images/location-service-icon.svg" alt="Location icon">
                </a>
                <i class="fa fa-angle-down position-absolute nav-color angle-right-icon" aria-hidden="true"></i>
              </form>
              <!-- Predictions Dropdown -->
              <div v-if="predictions.length" class="predictions-container position-absolute w-100 margin-top-1">
                <div 
                  v-for="(suggestion, index) in predictions" 
                  :key="index"
                  class="prediction-item padding-2 text-start bg-white border-bottom cursor-pointer text-full-13 text-size-14"
                  @click="selectSuggestion(suggestion)"
                >
                  {{ suggestion.description }}
                </div>
              </div>
            </div>

            <!-- Address Type Selection -->
            <div class="w-100 d-inline-block margin-top-3 home-work-other-btn text-center">
              <button
                type="button"
                :class="['text-black', 'text-size-14', 'inter-bold-family', 'bg-white', 'rounded-5', 'text-uppercase', 'd-inline-block', 'margin-right-2', 'text-full-13', { active: addressType === 'Home' }]"
                @click="addressType = 'Home'"
              >
                Home
              </button>
              <button
                type="button"
                :class="['text-black', 'text-size-14', 'inter-bold-family', 'bg-white', 'rounded-5', 'text-uppercase', 'd-inline-block', 'margin-right-2', 'text-full-13', { active: addressType === 'Work' }]"
                @click="addressType = 'Work'"
              >
                Work
              </button>
              <button
                type="button"
                :class="['text-black', 'text-size-14', 'inter-bold-family', 'bg-white', 'rounded-5', 'text-uppercase', 'd-inline-block', 'margin-right-2', 'text-full-13', { active: addressType === 'Other' }]"
                @click="addressType = 'Other'"
              >
                Other
              </button>
            </div>

            <!-- Address Form -->
            <form @submit.prevent="saveAddress">
              <div class="w-100 d-inline-block padding-2 bg-white rounded-3 margin-top-3 position-relative">
                <label class="w-100 d-inline-block text-black text-size-14 medium-family text-full-13">Use Current Location
                </label>
                <button 
                  type="button" 
                  class="w-100 bg-introduction text-size-14 h-40 padding-left-3 padding-right-3 border rounded-2 d-flex align-items-center justify-content-between 
                  text-full-13"
                  @click="getCurrentLocation"
                >
                  <span v-if="!loadingLocation">{{ address || "Get Current Location" }}</span>
                  <i v-if="loadingLocation" class="fa fa-spinner fa-spin"></i>
                  <img class="date-icon-image" src="@/assets/images/location-service-icon.svg" alt="Location">
                </button>
              </div>
              <div
                    v-if="addressType === 'Other'"
                    class="w-100 d-inline-block padding-2 bg-white rounded-3 margin-top-3"
                  >
                    <label class="w-100 d-inline-block text-black text-size-14 medium-family text-full-13">
                      Please specify address type
                    </label>
                    <input
                      v-model="otherAddressType"
                      class="w-100 bg-introduction text-size-16 h-40 padding-left-3 padding-right-3 border rounded-2 text-full-13"
                      type="text"
                      placeholder="Enter address type (e.g. Friend's Place, etc.)"
                      required
                    />
                  </div>
              <div class="w-100 d-inline-block padding-2 bg-white rounded-3 margin-top-3">
                <label class="w-100 d-inline-block text-black text-size-14 medium-family text-full-14">Flat / Villa No</label>
                <input v-model="flatNumber" class="w-100 bg-introduction text-size-16 h-40 padding-left-3 padding-right-3 border rounded-2 text-full-13" type="text" placeholder="Flat / Villa No" />
              </div>
             
              <div class="w-100 d-inline-block padding-2 bg-white rounded-3 margin-top-3">
                <label class="w-100 d-inline-block text-black text-size-14 medium-family text-full-13">
                  <input 
                    type="checkbox" 
                    v-model="sameAsPhone" 
                    @change="handleWhatsAppToggle"
                    class="me-2"
                  />
                  WhatsApp number is same as phone number
                </label>
              </div>
              <div class="w-100 d-inline-block padding-2 bg-white rounded-3 margin-top-3">
                <label class="w-100 d-inline-block text-black text-size-14 medium-family text-full-13">WhatsApp No</label>
                <input 
                  v-model="whatsAppNumber" 
                  :disabled="sameAsPhone"
                  class="w-100 bg-introduction text-size-16 h-40 padding-left-3 padding-right-3 border rounded-2 text-full-13" 
                  type="text" 
                  placeholder="3xxxxxxxxx" 
                />
              </div>
              <div class="w-100 d-inline-block padding-2 bg-white rounded-3 margin-top-3 margin-bottom-3">
                <label class="w-100 d-inline-block text-black text-size-14 medium-family text-full-13">
                  Directions <span class="strike-text">(Optional)</span>
                </label>
                <input v-model="directions" class="w-100 bg-introduction text-size-16 h-40 padding-left-3 padding-right-3 border rounded-2 text-full-13" type="text" placeholder="Directions " />
              </div>
              <div class="w-100 d-inline-block margin-top-3 mb-3">
                <button type="submit" class="w-100 d-inline-block text-white text-size-14 inter-regular-family rounded-5 padding-2 text-uppercase text-center bg-blue border-0 text-full-13">
                  Save Address
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--end address detail modal -->
    <!--start payment detail modal -->
    <div class="modal fade" id="PaymentDetailModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content bg-introduction rounded-3">
          <div class="modal-header pb-0 border-bottom-0 padding-top-3 padding-left-3 padding-right-3 w-100 d-inline-block">
            <h1 class="dark-black text-size-14 text-full-13 fw-bold padding-top-2 inter-semi-bold">Checkout
            <button type="button" class="btn-close mt-0 rounded-circle p-0 d-inline-block close-btn float-end m-0 text-size-14 text-full-13" @click="closeModal('PaymentDetailModal')" aria-label="Close"></button>
          </h1>
          </div>
          <div class="modal-body padding-2">
            <form @submit.prevent="submitForm">
              <!-- Payment Method Selection -->
              <div class="row margin-top-2">
                <!-- <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6">
                  <div class="w-100 d-inline-block dabit-card-box text-center" @click="setPaymentMethod('card')">
                    <a class="text-black text-size-14 rounded-2 d-inline-block w-100 bg-white inter-semi-bold text-full-13" href="javascript:void(0)" :class="{'activebtn': paymentMethod === 'card'}">
                      <img src="@/assets/images/debit-card-image.svg" alt="Card" />
                      Credit / Debit Card
                    </a>
                  </div>
                </div> -->
                <div class="col-xl-12 col-12 col-sm-12 col-md-12 col-lg-12 mt-xl-0 mt-3 mt-md-0 mt-lg-0">
                  <div class="w-100 d-inline-block dabit-card-box text-center" @click="setPaymentMethod('cash')">
                    <a class="text-black text-size-14 text-full-13 rounded-2 d-inline-block w-100 bg-white inter-semi-bold" href="javascript:void(0)" :class="{'activebtn': paymentMethod === 'cash'}">
                      <img src="@/assets/images/cash-image-icon.svg" alt="Cash" />
                      Cash (+5 AED)
                    </a>
                  </div>
                </div>
              </div>

              <!-- Card Payment Fields (Visible Only for Card) -->
              <!-- <div v-if="paymentMethod === 'card'" class="row margin-top-3">
                <div class="col-xl-6 col-12">
                  <div class="bg-white padding-2 rounded-2 w-100 d-inline-block customer-form">
                    <label class="fw-bold text-black margin-bottom-2 text-size-14 text-full-13">Card Holder Name
                    </label>
                    <input v-model="form.cardHolderName" class="bg-white w-100 d-inline-block border-color form-control box-shadow text-size-16 text-full-13" type="text" placeholder="Full Name" required />
                  </div>
                </div>
                <div class="col-xl-6 col-12">
                  <div class="bg-white p-2 rounded-2 w-100 d-inline-block customer-form">
                    <label class="fw-bold text-black mb-2 text-size-14 text-full-13">Card Number</label>
                    <input v-model="form.cardNumber" class="bg-white w-100 d-inline-block border-color form-control box-shadow text-size-16 text-full-13" type="number" placeholder="xxxx-xxxx-xxxx-xxxx" required />
                  </div>
                </div>
                <div class="col-xl-6 col-12">
                  <div class="bg-white p-2 rounded-2 margin-top-2 w-100 d-inline-block customer-form date-select-picker position-relative" onclick="document.querySelector('.date').showPicker()">
                    <label class="fw-bold text-black mb-2 text-size-14 text-full-13">Exp. Date</label>
                    <input v-model="form.expDate" class="bg-white w-100 d-inline-block border-color form-control box-shadow text-size-16 custom-date date text-full-13" type="date" />
                    <img class="custom-calendar-icon custom-calendar-icon-2" src="@/assets/images/calendar-image-icon.svg" alt="picture" />
                  </div>
                </div>
                <div class="col-xl-6 col-12">
                  <div class="bg-white p-2 rounded-2 margin-top-2 w-100 d-inline-block customer-form">
                    <label class="fw-bold text-black mb-2 text-size-14 text-full-13">CVV Number</label>
                    <input v-model="form.cvv" class="bg-white w-100 d-inline-block border-color form-control box-shadow text-size-16 text-full-13" type="number" placeholder="123" required />
                  </div>
                </div>
              </div> -->

              <!-- Discount Code -->
              <div class="col-12 margin-top-2">
                <div class="w-100 d-inline-block bg-white padding-2 rounded-2 w-xs-100 w-sm-100 w-md-100 w-ipad-100 input-discount">
                  <label class="fw-bold text-black mb-2 text-size-14 text-full-13">Discount Voucher Code</label>
                  <input v-model="form.discountCode" class="w-80 bg-introduction text-size-16 h-40 padding-left-3 padding-right-3 text-full-13 border float-start" type="text" placeholder="Enter Code" />
                  <button type="button" class="text-size-14 text-white fw-bold h-40 float-start bg-text bg-green ps-xl-3 ps-1 pe-xl-3 pe-1 medium-family border-0 text-full-13">Apply</button>
                </div>
              </div>
              <!-- Submit Button -->
              <div class="col-12 margin-top-3 margin-bottom-3">
                <!-- <button type="submit" 
                  class="btn w-100 d-inline-block bg-blue rounded-5 text-white fw-bold text-size-14 padding-2 inter-semi-bold text-full-13">
                  Confirm and Pay
                </button> -->
                <button
                  type="submit"
                  class="bg-green rounded-5 text-white d-inline-block padding-1 w-100 inter-semi-bold text-size-14 text-full-14 line-height-25 mb-4 border-0"
                  :disabled="confirming"
                >
                  <span v-if="!confirming">Confirm and Pay</span>
                  <span v-else><i class="fa fa-spinner fa-spin"></i> Processing...</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--end address detail modal -->
    <!--start thank you modal -->
    <div class="modal fade" id="ThankYouModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header pb-0 border-bottom-0 padding-top-3 padding-left-3 padding-right-3 w-100 d-inline-block">
            <button type="button" class="btn-close mt-0 rounded-circle p-0 d-inline-block close-btn float-end m-0" @click="closeModal('ThankYouModal')" aria-label="Close"></button>
          </div>
          <div class="modal-body padding-2">
            <div class="w-100 d-inline-block text-center">
                <img class="back-me-image" src="@/assets/images/back-home-image.png" alt="picture">
                  <h1 class="mb-0 text-size-14 text-black filson-black-family fw-bold margin-top-3 text-full-14">
                    {{ customerName }}
                  </h1>
                  <p class="mb-0 text-size-14 text-black inter-regular-family margin-top-2 text-full-13">
                    We appreciate your trust in our services and glad to be a part of your pet's health journey. We look forward to servicing you again. Happy pet grooming session!
                  </p>
                  <div class="w-100 d-inline-block text-center margin-top-3 position-relative">
                      <img class="pdf-image position-absolute" src="@/assets/images/pdf-image.png" alt="picture">
                      <a class="bg-introduction text-size-14 nav-color fw-bold filson-black-family download-btn d-inline-block position-relative padding-3 
                      margin-left-4 text-full-13" href="javascript:void(0)"
                       @click="downloadBookingPDF"
                       >
                        <span>Download Booking Details
                        </span>
                      </a>
                  </div>
                  <div class="w-100 d-inline-block text-center margin-top-2 margin-bottom-3">
                    <!-- <a class="text-white text-size-14 bg-green border-green rounded-5 inter-semi-bold text-uppercase pt-2 pb-2 ps-4 pe-4 d-inline-block" href="javascript:void(0)">
                    Back to home
                  </a> -->
                  <router-link class="text-white text-size-14 bg-green border-green rounded-5 inter-semi-bold text-uppercase padding-top-2 padding-bottom-2 padding-right-4 padding-left-4 d-inline-block text-full-13" to="/">Back to home
                  </router-link>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <!--end thank you modal -->
  </div>
</template>

<script>
import { initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import axios from 'axios';
import PhoneNumberInput from '../PhoneNumberInput.vue';
import { bookingDataStore } from '@/stores/bookingDataStore';

// import { ref, reactive } from 'vue';
  export default {
    name: "selectDateBannerComponent",
    components: {
      PhoneNumberInput
    },
    data() {
      return {
        isPhoneValid: false,
        userInformation: '',
        tooltipIndex: null,
        bookingId: '',
        customerName: '',
        customerEmail: '',
        customerPhone: '',
        customerAddress: '',
        whatsAppNumber: '',
        sameAsPhone: false,
        otherAddressType: '',
        loading: false,
        confirming: false,
        verifying: false,
        loadingLocation: false,
        paymentMethod: 'cash',
        searchQuery: '',
      predictions: [],
      selectedPlace: null,
        form: {
          cardHolderName: '',
          cardNumber: '',
          expDate: '',
          cvv: '',
          discountCode: '',
        },
       // Hide cash section
        activeLink: null,
        timeSlots: [],
        startDate: new Date(), // Start from today's date
        displayedDates: [], 
        activeLink2: null,
        cart: JSON.parse(localStorage.getItem("cart")) || [],
        selectedDurationFrom: null,
        selectedDurationTo: null,
        selectedDate: null,
        phoneNumber: "",
        otp: "",
        otpSent: false,
        confirmationResult: null,
        phone_number:'',
        firebase_uid:'',
        authUserId:'',

        formData: {
          name: '',
          email: '',
          gender: '',
          whatsApp: ''
        },
        map: null,
        marker: null,
        address: '',
        flatNumber: '',
        directions: '',
        addressType: 'Home',
        lat: null,
        lng: null,
        suggestions: [],
        google: null,
      };
    },
    created() {
    this.generateDates(); 
    this.selectCurrentDate();
  },
  mounted() {
    this.generateTimeSlots();
    this.cartAddress = localStorage.getItem('cartAddress') || '';
    // If address was previously saved, show it in the input field
    if (this.cartAddress) {
      this.searchQuery = this.cartAddress;
    }
    const userInfo = JSON.parse(localStorage.getItem('userInformation'));
    if (userInfo && userInfo.phone) {
      this.phoneNumber = userInfo.phone;
    }
  },
    computed: {
    cartTotal() {
      return this.cart.reduce((total, item) => total + item.price * item.count, 0);
    },
  },
  methods: {
    otpWhatsapp() {
      const phoneNumber = "+971522809076"; // Replace with your phone number in international format
      const message = "Hello I am having issue in receiving OTP and I want to book appointment."; // Replace with your custom message
      const encodedMessage = encodeURIComponent(message);
      const whatsappUrl = `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${encodedMessage}&type=phone_number&app_absent=0`;
      window.open(whatsappUrl, "_blank");
      if(this.isValid && this.phoneNumber){
        this.progressAppointment();
      }
    },
    async progressAppointment(){
      const appointmentData = {
        duration_from: this.selectedTimeSlot,
        appointment_date: this.selectedDate,
        cart: this.cart,
        phone_number: this.phoneNumber,
      };
     const response = await this.$axios.post('/progress-appointment', appointmentData);
     console.log(response.data);
        // this.cart = [];
        // this.bookingId = response.data.booking.id;
        // this.customerName = response.data.booking.customer_name;
        // this.customerEmail = response.data.booking.customer_email;
   },
     onPhoneValidationChanged(isValid) {
      this.isPhoneValid = isValid;
      // console.log('Phone validation changed:', isValid, 'Phone:', this.phoneNumber);
    },
    handleWhatsAppToggle() {
      if (this.sameAsPhone) {
        this.whatsAppNumber = this.phoneNumber;
      } else {
        this.whatsAppNumber = '';
      }
    },
    getOpenModal() {
    
    const openModal = document.querySelector('.modal.show'); // Select the modal with the 'show' class
    if (openModal) {
      return openModal.id; // Return the ID of the open modal
    }
    return null; // Return null if no modal is open
  },
  showTooltip(index) {
    this.tooltipIndex = index;
  },
  hideTooltip() {
    this.tooltipIndex = null;
  },
  removeItem(index) {
    this.cart.splice(index, 1);
  },
      setPaymentMethod(method) {
        this.paymentMethod = method;
      },
      async submitForm() {
        const nextElement = document.querySelector('.showNext');
        if (nextElement) {
          nextElement.style.display = 'none';
        }
        this.confirming = true;
        try {
          const paymentData = {
            paymentMethod: this.paymentMethod,
            discountCode: this.form.discountCode,
          };

          if (this.paymentMethod === 'card') {
            paymentData.cardHolderName = this.form.cardHolderName;
            paymentData.cardNumber = this.form.cardNumber;
            paymentData.expDate = this.form.expDate;
            paymentData.cvv = this.form.cvv;
          }
          const response = await axios.post('/checkout', paymentData);
          // alert('Payment Successful');
          // console.log(response.data);
          if(response.data.payment_status=='Cash on Delivery'){
            // const fullWhatsappNumber = `+92${this.whatsAppNumber}`;
            // const fullWhatsappNumber = `+92${this.whatsAppNumber}`;
              const appointmentData = {
                duration_from: this.selectedTimeSlot,
                appointment_date: this.selectedDate,
                cart: this.cart,
                phone_number: this.phoneNumber,
                whatsapp_number: this.whatsAppNumber,
                authUserId: this.authUserId,
              };
              const response = await this.$axios.post('/save-appointment', appointmentData);
              this.cart = [];
              this.bookingId = response.data.booking.id;
              this.customerName = response.data.booking.customer_name;
              this.customerEmail = response.data.booking.customer_email;
              localStorage.removeItem('cart');
              // this.$router.push({
              //   path: '/backHome',
              //   query: {
              //     successMessage: 'Appointment saved successfully!',
              //     data: JSON.stringify(response.data),
              //   },
              // });
              // this.$router.push({
              //   path: '/backHome',
              //   query: {
              //     successMessage: 'Appointment saved successfully!',
              //     data: JSON.stringify(response.data),
              //   },
              // });

              // this.closeModal('PaymentDetailModal');
              // this.openModal('ThankYouModal');
            bookingDataStore.customerName = this.customerName;
            bookingDataStore.bookingId = this.bookingId;
            this.closeModal('PaymentDetailModal');
            this.$router.push('/booking/thank-you');

            this.$toast.success('Appointment Booked.Keep Cash Ready');
            
          }
          if(response.data.payment_status=='Paid via Credit/Debit Card'){
            this.closeModal('PaymentDetailModal');
            this.$toast.success('Payment Successful');
            
          }
        } catch (error) {
          console.error(error);
          this.$toast.error('Payment Failed');
        }
        this.confirming = false;
      },

      generateDates() {
      this.address = localStorage.getItem('cartAddress') || '';
      this.displayedDates = [];
      let currentDate = new Date(this.startDate);
      for (let i = 0; i < 10; i++) {
        this.displayedDates.push({
          day: currentDate.toLocaleDateString("en-US", { weekday: "short" }),
          date: currentDate.getDate(),
          month: currentDate.toLocaleDateString("en-US", { month: "short" }),
          fullDate: currentDate.toISOString().split("T")[0], // Format: 2024-11-22
        });
        currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
      }
    },
    loadNextDates() {
      this.startDate.setDate(this.startDate.getDate() + 10); // Move startDate 10 days ahead
      this.generateDates(); 
    },
    loadPrevDates() {
    this.startDate.setDate(this.startDate.getDate() - 10); // Move startDate 10 days back
    this.generateDates(); 
  },
    setActiveLink2(index) {
      this.activeLink2 = index;
      const selectedDate = this.displayedDates[index - 1].fullDate;
      this.selectedDate = selectedDate;
      this.generateTimeSlots();
    },
    scrollToNextButton() {
      const nextButton = this.$refs.nextButton;
      if (nextButton) {
        nextButton.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    },
    
    // async generateTimeSlots() {
    //   try {
    //       const response = await this.$axios.post('/website-timing', { appointment_date: this.selectedDate });
    //       if (response.data.success) {
    //           this.timeSlots = response.data.all_slots.map(slot => ({
    //               time: slot,
    //               isAvailable: response.data.available_slots.includes(slot),
    //           }));
    //       } else {
    //           console.error('Error fetching slots:', response.data.message || 'Unknown error');
    //           this.timeSlots = [];
    //       }
    //   } catch (error) {
    //       console.error('Error fetching slots:', error);
    //       this.timeSlots = [];
    //   }
    // },
async generateTimeSlots() {
  try {
    const response = await this.$axios.post('/website-timing', {
      appointment_date: this.selectedDate,
    });

    if (response.data.success) {
      const availableSlots = response.data.available_slots;

      this.timeSlots = response.data.all_slots.map(slot => ({
        time: slot,
        isAvailable: availableSlots.includes(slot),
      }));

      // ✅ Automatically activate the first available slot
      const firstAvailableIndex = this.timeSlots.findIndex(slot => slot.isAvailable);
      if (firstAvailableIndex !== -1) {
        this.setActiveLink(firstAvailableIndex, this.timeSlots[firstAvailableIndex]);
      } else {
        this.activeLink = null;
      }

    } else {
      console.error('Error fetching slots:', response.data.message || 'Unknown error');
      this.timeSlots = [];
      this.activeLink = null;
    }
  } catch (error) {
    console.error('Error fetching slots:', error);
    this.timeSlots = [];
    this.activeLink = null;
  }
},
    // setActiveLink(index, slot) {
    //   this.activeLink = index;
    //   this.selectedDurationFrom = slot;
    //   this.scrollToNextButton();
    // },
    setActiveLink(index, slot) {
      this.activeLink = index;
      this.selectedTimeSlot = slot.time; 
      this.scrollToNextButton();
    },
    selectCurrentDate() {
      // Automatically select the current date
      this.activeLink2 = 1; // Index starts at 1 for the first date
      this.selectedDate = this.displayedDates[0]?.fullDate; // Set the first date as selected
    },
    async saveAppointment() {
      const openModalId = this.getOpenModal();
      if (openModalId) {
        // console.log(`The currently open modal is: ${openModalId}`);
        if (openModalId === 'MobileNumberModal') {
          if (!this.otpSent) {
            const modalElement = document.getElementById(openModalId);
            const submitButton = modalElement.querySelector('button[type="submit"]'); // Find the submit button
            if (submitButton) {
              submitButton.click(); // Programmatically click the submit button
              return;
            } else {
              console.error('Submit button not found in the modal.');
              return;
            }
          } else {
            // Trigger the verifyOtp functionality
            this.verifyOtp();
            return;
          }
        }
        if (openModalId === 'ContactDetailModal') {
          this.saveUser(); // Call the saveUser method directly
          return;
        }
        if (openModalId === 'AddressDetailModal') {
          this.saveAddress(); // Call the saveAddress method directly
          return;
        }
        if (openModalId === 'PaymentDetailModal') {
          this.submitForm(); 
          // const nextElement = document.querySelector('.showNext');
          //   if (nextElement) {
          //     nextElement.style.display = 'none';
          //   }
          return;
        }
      } else {
        console.log('No modal is currently open.');
      }
      try {
        // Check if cart is empty
        if (!this.cart || this.cart.length === 0) {
          this.$toast.error('Please, select a service first.');
          return;
        }
        if (!this.selectedTimeSlot || !this.selectedDate) {
          this.$toast.error('Both Appointment Date and Time are required.');
          return;
        }
        const userInformationRaw = localStorage.getItem('userInformation');
        if (!userInformationRaw) {
          this.openModal('MobileNumberModal');
          return;
        }else{
          const userInformation = JSON.parse(userInformationRaw);

          // Populate the form with saved values
          this.phoneNumber = userInformation.phone_number || '';
          this.searchQuery = userInformation.address || '';
          this.flatNumber = userInformation.flatNumber || '';
          this.whatsAppNumber = userInformation.whatsAppNumber || '';
          this.directions = userInformation.directions || '';
          this.addressType = userInformation.address_type || '';
          this.sameAsPhone = userInformation.sameAsPhone || '';
          this.lat = userInformation.lat || null;
          this.lng = userInformation.lng || null;
          this.authUserId = userInformation.authUserId || null;
           this.openModal('AddressDetailModal');
          return;
        }
        // Check if the user is logged in
        // const isLoggedInResponse = await this.$axios.get('/is-user-logged-in');
        // if (!isLoggedInResponse.data.isLoggedIn) {
        //   this.openModal('MobileNumberModal');
        //   return;
        // }
       
      } catch (error) {
        this.$toast.error('Failed to save appointment. Please try again.');
      }
    },
    openModal(id){
      const modalElement = document.getElementById(id);
      modalElement.classList.add('show'); // Add the 'show' class
      modalElement.style.display = 'block'; // Make it visible
      document.body.classList.add('modal-open'); // Prevent background scrolling
    },
closeModal(id) {
  const modalElement = document.getElementById(id);
  modalElement.classList.remove('show'); // Remove the 'show' class
  modalElement.style.display = 'none'; // Hide the modal
  document.body.classList.remove('modal-open'); // Allow background scrolling

  // Remove the backdrop if it exists
  const backdrop = document.querySelector('.modal-backdrop');
  if (backdrop) {
    backdrop.parentNode.removeChild(backdrop);
  }
},
  initializeFirebase() {
      const firebaseConfig = {
        apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
        authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
        projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.VUE_APP_FIREBASE_APP_ID,
        measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
      };
      initializeApp(firebaseConfig);
    },
    setupRecaptcha() {
      const auth = getAuth();
      window.recaptchaVerifier = new RecaptchaVerifier(auth, 
        "recaptcha-container",
        {
          size: "invisible",
        }
      );
    },
    async sendOtp() {
      try {
        // 1. Add phone number validation
        if (!this.phoneNumber || this.phoneNumber.trim() === '') {
          this.$toast.error('Please enter your phone number');
          return;
        }

        // console.log('Sending OTP to:', this.phoneNumber);

        this.loading = true;
        this.initializeFirebase();
        // 2. Clear existing recaptcha before setting up new one
        if (window.recaptchaVerifier) {
          try {
            window.recaptchaVerifier.clear();
          } catch (e) {
            console.log('Error clearing recaptcha:', e);
          }
          window.recaptchaVerifier = null;
        }
        
        // 3. Setup fresh recaptcha
        this.setupRecaptcha();

        const auth = getAuth();
        const appVerifier = window.recaptchaVerifier;

        // 4. Send OTP with the phone number from PhoneNumberInput
        const confirmationResult = await signInWithPhoneNumber(auth, this.phoneNumber, appVerifier);
        
        // console.log('confirmationResult', confirmationResult);
        this.otpSent = true;
        this.confirmationResult = confirmationResult;
        this.$toast.success('OTP sent successfully!');
        
      } catch (error) {
        console.error("Error sending OTP:", error);
        this.progressAppointment();
        // 5. Clear recaptcha on error
        if (window.recaptchaVerifier) {
          try {
            window.recaptchaVerifier.clear();
          } catch (e) {
            console.log('Error clearing recaptcha on error:', e);
          }
          window.recaptchaVerifier = null;
        }
        
        // 6. Handle specific errors
        if (error.code === 'auth/invalid-phone-number') {
          this.$toast.error('Invalid phone number format');
        } else if (error.code === 'auth/too-many-requests') {
          this.$toast.error('Too many requests. Please try again later');
        } else {
          this.$toast.error('Failed to send OTP: ' + error.message);
        }
      } finally {
        this.loading = false;
      }
    },
 

    async verifyOtp() {
      try {
        this.verifying = true;
        const result = await this.confirmationResult.confirm(this.otp);
        const userIdToken = await result.user.getIdToken();

        // Send the token to the backend
        await this.validateUser(userIdToken);
        console.log("OTP verified successfully!");
        this.$toast.success('OTP verified successfully!');
      } catch (error) {
        console.error("Error verifying OTP:", error);
        this.$toast.error('Failed to verify OTP');
        // alert("Failed to verify OTP.");
        this.progressAppointment();
      } finally {
        this.verifying = false; // Hide loader after completion
      }

    },
    async validateUser(token) {
      try {
        const response = await this.$axios.post("/validate-user", { token });
        console.log("User saved:", response.data);
        if(response.data.statusCode == 201){

        this.firebase_uid = response.data.uid;
        this.phone_number = response.data.phone_number;
        this.closeModal('MobileNumberModal');
        this.openModal('ContactDetailModal');
        }
        else if(response.data.statusCode == 200){
        this.firebase_uid = response.data.uid;
        this.phone_number = response.data.phone_number;
        this.closeModal('MobileNumberModal');
        // this.initMap();
        this.openModal('AddressDetailModal');
        }
        else{
          this.$toast.error('OTP verification failed.');
        }
      } catch (error) {
        console.error("Error saving user:", error);
      }
    },
    selectGender(gender) {
        console.log("gender", gender);

    this.formData.gender = gender;
  },
    async saveUser() {
    try {
      // Add firebase_uid and phone_number to the formData before sending the request
      const formData = {
        name: this.formData.name,
        email: this.formData.email,
        gender: this.formData.gender,
        whatsApp: this.formData.whatsApp,
        firebase_uid: this.firebase_uid,  // Add Firebase UID
        phone_number: this.phoneNumber   // Add phone number
      };

      // Send the updated formData to the backend
      const response = await this.$axios.post('/save-user', formData);
      this.authUserId = response.data.user.id; 
      // console.log('User id for auth:', this.authUserId);
      console.log('User information saved:', response.data);
      if(response.data.statusCode == 200){
        this.closeModal('ContactDetailModal');
        // this.initMap();
        this.openModal('AddressDetailModal');
        }
        else{
          this.$toast.error('Failed to save User Information');
        }
      // Close the modal or handle success
    } catch (error) {
      console.error('Error saving user information:', error);
    }
  },
    selectSuggestion(suggestion) {
      this.searchQuery = suggestion.description;
      this.address = suggestion.description;
      this.predictions = [];
    },
    saveAddress() {
      // console.log("Selected Address Type: ", this.addressType);
      const payload = {
        phone_number: this.phoneNumber,
        whatsAppNumber: this.whatsAppNumber,
        address: this.searchQuery,
        flatNumber: this.flatNumber,
        directions: this.directions,
        sameAsPhone: this.sameAsPhone,
        address_type: this.addressType === 'Other' ? this.otherAddressType : this.addressType,
        lat: this.lat,
        lng: this.lng,
        authUserId: this.authUserId,
      };

    localStorage.setItem('userInformation', JSON.stringify(payload));
    this.userInformation = payload;
      // Send data to backend
      this.$axios.post('/save-address', payload)
        .then((response) => {
          console.log('Address saved:', response.data);
          this.$toast.success('Address saved successfully!');
          this.closeModal('AddressDetailModal');
          this.openModal('PaymentDetailModal');
        })
        .catch((error) => {
          console.error('Error saving address:', error);
        });
    },
    
    async handleInput() {
      if (this.searchQuery.trim().length > 1) {
        const result = await this.searchPlaces(this.searchQuery);
        if (result && result.predictions) {
          this.predictions = result.predictions;
        }
      } else {
        this.predictions = []; // Clear predictions when input is empty
      }
    },
    async searchPlaces(query) {
      try {
        const response = await this.$axios.post("/search-places", { query });
        // console.log('response', response);
        return response.data;
      } catch (error) {
        console.error('Error fetching places:', error);
        return null;
      }
    },
    getCurrentLocation() {
      if (!navigator.geolocation) {
        this.$toast.error("Geolocation is not supported by your browser.");
        return;
      }

      this.loadingLocation = true;

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          // Call reverse geocoding API to get address
          this.fetchAddressFromCoords(latitude, longitude);
        },
        (error) => {
          console.error("Error getting location:", error);
          this.$toast.error("Unable to retrieve your location.");
          this.loadingLocation = false;
        }
      );
    },

    async fetchAddressFromCoords(lat, lng) {
      try {
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=d7482c80a5dc46d2b9578fd206d6a4f6`
        );
        const data = await response.json();

        if (data.status === "OK") {
          this.address = data.results[0].formatted_address;
        } else {
          this.$toast.error("Could not fetch address.");
        }
      } catch (error) {
        console.error("Geocoding error:", error);
        this.$toast.error("Error fetching address.");
      } finally {
        this.loadingLocation = false;
      }
    },
    async downloadBookingPDF() {
      try {
        const response = await this.$axios.get(`/download-booking/${this.bookingId}`, {
          responseType: 'blob' // Ensure the response is treated as a file
        });

        // Create a Blob URL for the file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'booking_details.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        this.$toast.success('Booking PDF downloaded successfully!');
      } catch (error) {
        console.error("Error downloading PDF:", error);
        this.$toast.error('Failed to download booking details.');
      }
    }

    // async downloadBookingPDF() {
    //   try {
    //     const response = await this.$axios.get(`/download-booking/${this.bookingId}`, {
    //       responseType: 'blob' // Ensure the response is treated as a file
    //     });

    //     // Create a Blob URL for the file
    //     const url = window.URL.createObjectURL(new Blob([response.data]));
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.setAttribute('download', 'booking_details.pdf');
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
        
    //     this.$toast.success('Booking PDF downloaded successfully!');
    //   } catch (error) {
    //     console.error("Error downloading PDF:", error);
    //     this.$toast.error('Failed to download booking details.');
    //   }
    // }

    },
  };
</script>

<style scoped>
/* Add your custom styles to adjust the slot design */

.activeTime {
  background-color: #007bff;
  color: #fff;
  border-color: #00b7af;
}
.active {
  background-color: #00b7af !important;
  color: white !important;
}
</style>
